import axios from 'axios'
import React, { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'
//const uuidv4 = require('uuid/v4')

export default function Modal({ setOpenModal, modalInfo }) {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser()
  const [gerencias, setGerencia] = useState([])
  const [modal, setModal] = useState(false)
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/gerencia/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setGerencia(response.data)
      })
  }, [])

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdUnidade: modalInfo.IdUnidade,
    IdEmpresa: modalInfo.IdEmpresa,
    uniNome: modalInfo.uniNome,
    uniRazaoSocial: modalInfo.uniRazaoSocial,
    uniCNPJ: modalInfo.uniCNPJ,
    uniLogo: modalInfo.uniLogo,
    uniEndereco: modalInfo.uniEndereco,
    uniStatus: modalInfo.uniStatus,
    uniObservacoes: modalInfo.uniObservacoes,
    uniAlteradoPor: user[0].pesEmail,
    uniAlteradoEm: newDate,
    uniSubUnidades: modalInfo.uniSubUnidades
  })

  const [camposLocal, setCamposLocal] = useState({
    IdLocalArea: '',
    IdEmpresa: modalInfo.IdEmpresa,
    IdUnidade: modalInfo.IdUnidade,
    IdGerencia: 0,
    locDescricao: '',
    locReferencia: '',
    locStatus: 1,
    locObservacoes: '',
    locCriadoPor: user[0].pesEmail,
    locCriadoEm: newDate,
    locAlteradoPor: user[0].pesEmail,
    locAlteradoEm: newDate,
    locCodigoGUID: uuidv4
  })

  function handleInputChange(event) {
    if (event.target.name === 'uniStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else if (event.target.name === 'uniSubUnidades') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    }
    else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
    //console.log(campos)
  }

  function handleFormSubmit(event) {
    event.preventDefault()
    //se a unidade não terá sub unidades
    if (campos.uniSubUnidades === 0) {
      //avisa e aguarda ação do usuário
      if (window.confirm('Essa Unidade não permitirá Cadastrar novas Sub-Unidades (Locais). \n Deseja continuar e Salvar?')) {
        axios
          .put(
            process.env.REACT_APP_API_URL + '/api/v1/unidade/' + campos.IdUnidade,
            campos
          )
          .then(response => {
            //precisa validar se a unidade já tem uma sub e cadastra com os mesmos dados
            axios
              .get(
                process.env.REACT_APP_API_URL +
                '/api/v1/area/list/' +
                campos.IdEmpresa +
                '/' +
                campos.IdUnidade
              ).then(resp => {
                //valida se não tiver local cadastra o primeiro
                if (!resp.data[0]) {
                  //alert('sem local')
                  camposLocal.locDescricao = campos.uniNome
                  setCamposLocal(camposLocal)
                  console.log(camposLocal)
                  axios
                    .post(process.env.REACT_APP_API_URL + '/api/v1/area',
                      camposLocal)
                    .then(respLoc => {
                      alert(response.data.message + "\n \n" + respLoc.data.message)
                      window.location.reload()
                    })
                  //alert(response.data.message + "\n \n" + resp.data.message)
                }
                else {
                  alert(response.data.message)
                  window.location.reload()
                }
              })
            //window.location.reload()
          })
      }
    }
    //terá novas unidades
    else {
      axios
        .put(
          process.env.REACT_APP_API_URL + '/api/v1/unidade/' + campos.IdUnidade,
          campos
        )
        .then(response => {
          alert(response.data.message)
          window.location.reload()
        })
    }
  }
  return (
    <div className="modalArea">
      <div onClick={toggleModal} className="overlay"></div>
      <div className="modalPadrao-content">
        <div className="cxTituloPadrao">
          <h1>
            Editar Unidade
            <hr className="hrTitleModal" />
          </h1>
          <button
            className="close-modal"
            onClick={() => {
              setOpenModal(false)
            }}
          >
            X
          </button>
        </div>

        <form onSubmit={handleFormSubmit}>
          <div className="lineModal">
            <label>Nome Fantasia:</label>
            <label>CNPJ:</label>
          </div>
          <div className="lineModal">
            <input
              type="text"
              autoComplete="nope"
              id="fname"
              onChange={handleInputChange}
              name="uniNome"
              defaultValue={campos.uniNome}
            />
            <input
              type="text"
              autoComplete="nope"
              id="fname"
              onChange={handleInputChange}
              name="uniCNPJ"
              defaultValue={campos.uniCNPJ}
            />
          </div>
          <label>Razão Social:</label>
          <input
            placeholder="Razão Social"
            type="text"
            id="fname"
            defaultValue={campos.uniRazaoSocial}
            name="uniRazaoSocial"
            onChange={handleInputChange}
          ></input>
          <label>Endereço:</label>
          <input
            type="text"
            autoComplete="nope"
            id="fname"
            onChange={handleInputChange}
            name="uniEndereco"
            defaultValue={campos.uniEndereco}
          />

          <label>Observações:</label>
          <textarea
            placeholder="Observações"
            type="text"
            id="fname"
            name="uniObservacoes"
            defaultValue={campos.uniObservacoes}
            row="none"
            onChange={handleInputChange}
            maxLength="500"
          ></textarea>

          <div className="caixaSalvarPadrao">
            <div className="InputAuthorization4">
              <label>
                <input
                  name="uniStatus"
                  type="checkbox"
                  defaultChecked={!!campos.uniStatus}
                  onChange={handleInputChange}
                />
                <span>Status</span>
              </label>
            </div>
            <div className="InputAuthorization5">
              <label>
                <input
                  name="uniSubUnidades"
                  type="checkbox"
                  defaultChecked={!!campos.uniSubUnidades}
                  onChange={handleInputChange}
                />
                <span>Possui sub-unidades (Locais)?</span>
              </label>
            </div>
            <button type="submit">Salvar Registro</button>
          </div>

        </form>
      </div>
    </div>
  )
}
